export class UpdateCaracteristicaRequest {
    public id: number =0
    public descripcion : string="";
}